"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AnimatedContainer_1 = __importDefault(require("./AnimatedContainer"));
var ModalWindow_1 = __importDefault(require("./ChatWidget/ModalWindow"));
var ConfirmCloseModal_1 = __importDefault(require("./ConfirmCloseModal"));
var config_1 = require("../constants/config");
require("../../src/app.css");
require("bootstrap/dist/css/bootstrap.min.css");
var retellClient_1 = require("../services/retellClient");
var HeaderBar_1 = __importDefault(require("./HeaderBar"));
var WelcomeView_1 = __importDefault(require("../views/WelcomeView"));
var CallView_1 = __importDefault(require("../views/CallView"));
var ChatView_1 = __importDefault(require("../views/ChatView"));
var MinimizedDock_1 = __importDefault(require("./MinimizedDock"));
var config_2 = require("../constants/config");
var mobileDetection_1 = require("../utils/mobileDetection");
function ChatWidget() {
    var _this = this;
    var _a = (0, react_1.useState)(false), visible = _a[0], setVisible = _a[1];
    var widgetRef = (0, react_1.useRef)(null);
    var isMobile = (0, mobileDetection_1.useIsMobile)();
    var _b = (0, react_1.useState)("checking"), micStatus = _b[0], setMicStatus = _b[1];
    var _c = (0, react_1.useState)("inactive"), callState = _c[0], setCallState = _c[1];
    var _d = (0, react_1.useState)(false), showConfirmClose = _d[0], setShowConfirmClose = _d[1];
    var _e = (0, react_1.useState)("welcome"), currentView = _e[0], setCurrentView = _e[1];
    var _f = (0, react_1.useState)(true), isMinimized = _f[0], setIsMinimized = _f[1];
    var _g = (0, react_1.useState)("welcome"), lastView = _g[0], setLastView = _g[1];
    var _h = (0, react_1.useState)(null), chatId = _h[0], setChatId = _h[1];
    var _j = (0, react_1.useState)(false), isStartingChat = _j[0], setIsStartingChat = _j[1];
    var chatInitRequestedRef = (0, react_1.useRef)(false);
    var _k = (0, react_1.useState)(null), micStream = _k[0], setMicStream = _k[1];
    var _l = (0, react_1.useState)((0, config_1.getWidgetConfig)().agentName), currentAgentName = _l[0], setCurrentAgentName = _l[1];
    var _m = (0, react_1.useState)("Speak With"), currentStage = _m[0], setCurrentStage = _m[1];
    var _o = (0, react_1.useState)(""), chatInput = _o[0], setChatInput = _o[1];
    var _p = (0, react_1.useState)([
        {
            id: "m1",
            role: "agent",
            text: "Hi, my name is Glo. How can I assist you today?",
            createdAt: Date.now() - 60000,
        },
    ]), chatMessages = _p[0], setChatMessages = _p[1];
    (0, react_1.useEffect)(function () {
        var saved = sessionStorage.getItem("retell_chat_id");
        if (saved)
            setChatId(saved);
    }, []);
    (0, react_1.useEffect)(function () {
        if (chatId)
            sessionStorage.setItem("retell_chat_id", chatId);
        else
            sessionStorage.removeItem("retell_chat_id");
    }, [chatId]);
    (0, react_1.useEffect)(function () {
        if (currentView !== "chat")
            return;
        if (chatId)
            return; // already have one
        if (chatInitRequestedRef.current)
            return; // already requested in this mount
        chatInitRequestedRef.current = true; // <-- block duplicates immediately
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var agentId, chat_id, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        setIsStartingChat(true);
                        agentId = config_2.widgetConfig.chatbotId;
                        return [4 /*yield*/, (0, retellClient_1.startChat)(agentId)];
                    case 1:
                        chat_id = (_a.sent()).chat_id;
                        setChatId(chat_id);
                        return [3 /*break*/, 4];
                    case 2:
                        e_1 = _a.sent();
                        console.error("Failed to start chat", e_1);
                        chatInitRequestedRef.current = false; // allow retry on error
                        return [3 /*break*/, 4];
                    case 3:
                        setIsStartingChat(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
    }, [currentView, chatId]);
    var handleMinimize = function () {
        setLastView(currentView);
        setIsMinimized(true);
    };
    var handleRestore = function () {
        setIsMinimized(false);
        setCurrentView(lastView || "welcome");
    };
    function checkMic() {
        return __awaiter(this, void 0, void 0, function () {
            var stream, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!navigator.mediaDevices || visible) {
                            setVisible(false);
                            setCurrentAgentName((0, config_1.getWidgetConfig)().agentName);
                            setCurrentStage("Speak With");
                            stopMicrophone();
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, navigator.mediaDevices.getUserMedia({
                                audio: true,
                                video: false,
                            })];
                    case 2:
                        stream = _b.sent();
                        setMicStream(stream);
                        window.retellMicrophoneStream = stream;
                        setMicStatus("active");
                        setVisible(true);
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        setMicStatus("denied");
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    var muteMicrophone = function () {
        var sdk = window.retellWebClient;
        if (sdk === null || sdk === void 0 ? void 0 : sdk.mute)
            sdk.mute();
        micStream === null || micStream === void 0 ? void 0 : micStream.getAudioTracks().forEach(function (t) { return (t.enabled = false); });
        setMicStatus("muted");
    };
    var unmuteMicrophone = function () {
        var sdk = window.retellWebClient;
        if (sdk === null || sdk === void 0 ? void 0 : sdk.unmute)
            sdk.unmute();
        micStream === null || micStream === void 0 ? void 0 : micStream.getAudioTracks().forEach(function (t) { return (t.enabled = true); });
        setMicStatus("active");
    };
    var stopMicrophone = function () {
        if (!micStream)
            return;
        micStream.getTracks().forEach(function (track) { return track.stop(); });
        setMicStream(null);
    };
    var endCallSession = function () {
        setVisible(false);
        setCurrentAgentName((0, config_1.getWidgetConfig)().agentName);
        setCurrentStage("Speak With");
        stopMicrophone();
        setCallState("offline");
    };
    var handleWidgetClick = function () {
        if (callState === "inactive") {
            checkMic();
            setCallState("active");
        }
        else if (callState === "active") {
            endCallSession();
        }
        else if (callState === "offline") {
            checkMic();
            setCallState("active");
        }
    };
    function toEpochMs(v) {
        if (typeof v === "number" && Number.isFinite(v))
            return v;
        var n = Number(v);
        return Number.isFinite(n) ? n : Date.now();
    }
    (0, react_1.useEffect)(function () {
        window.muteMicrophone = muteMicrophone;
        window.unmuteMicrophone = unmuteMicrophone;
        window.stopMicrophone = stopMicrophone;
    }, []);
    (0, react_1.useEffect)(function () { return function () { return stopMicrophone(); }; }, []);
    var panelWidth = isMinimized
        ? 0
        : isMobile
            ? currentView === "welcome"
                ? 280
                : currentView === "chat"
                    ? 320
                    : 300
            : currentView === "welcome"
                ? 280
                : currentView === "chat"
                    ? 330
                    : 380;
    var motionEasing = "cubic-bezier(.2,.8,.2,1)";
    var motionMs = 280;
    var _q = (0, react_1.useState)(false), sending = _q[0], setSending = _q[1];
    var handleSend = function () { return __awaiter(_this, void 0, void 0, function () {
        var trimmed, userMsg, id, cfg, agentId, start, res, mapped_1, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trimmed = chatInput.trim();
                    if (!trimmed || sending)
                        return [2 /*return*/];
                    userMsg = {
                        id: String(Date.now()),
                        role: "user",
                        text: trimmed,
                        createdAt: Date.now(),
                    };
                    setChatMessages(function (prev) { return __spreadArray(__spreadArray([], prev, true), [userMsg], false); });
                    setChatInput("");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, 6, 7]);
                    setSending(true);
                    id = chatId;
                    if (!!id) return [3 /*break*/, 3];
                    cfg = (0, config_1.getWidgetConfig)();
                    agentId = cfg.chatAgentId || cfg.agentId || "";
                    return [4 /*yield*/, (0, retellClient_1.startChat)(agentId)];
                case 2:
                    start = _a.sent();
                    id = start.chat_id;
                    setChatId(id);
                    _a.label = 3;
                case 3: return [4 /*yield*/, (0, retellClient_1.sendMessage)(id, trimmed)];
                case 4:
                    res = _a.sent();
                    mapped_1 = (res.messages || [])
                        .filter(function (m) { return m && typeof m.content === "string" && m.content.trim().length; })
                        .map(function (m) { return ({
                        id: m.message_id || String(Date.now() + Math.random()),
                        role: m.role === "assistant"
                            ? "agent"
                            : m.role,
                        text: m.content,
                        createdAt: toEpochMs(m.created_timestamp),
                    }); });
                    if (mapped_1.length) {
                        setChatMessages(function (prev) { return __spreadArray(__spreadArray([], prev, true), mapped_1, true); });
                    }
                    return [3 /*break*/, 7];
                case 5:
                    e_2 = _a.sent();
                    console.error("sendMessage error:", e_2);
                    setChatMessages(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
                        {
                            id: String(Date.now() + 2),
                            role: "agent",
                            text: "Sorry—there was a connection issue. Please try again.",
                            createdAt: Date.now(),
                        },
                    ], false); });
                    return [3 /*break*/, 7];
                case 6:
                    setSending(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    function appendAssistant(messages) {
        var assistantTexts = messages
            .filter(function (m) { var _a; return m.role === "assistant" && ((_a = m.content) === null || _a === void 0 ? void 0 : _a.trim()); })
            .map(function (m) { return ({
            id: String(Date.now() + Math.random()),
            role: "agent",
            text: m.content,
            timeLabel: "Just now",
        }); });
        if (assistantTexts.length) {
            setChatMessages(function (prev) { return __spreadArray(__spreadArray([], prev, true), assistantTexts, true); });
        }
    }
    function useNow(intervalMs) {
        var _a = (0, react_1.useState)(Date.now()), now = _a[0], setNow = _a[1];
        (0, react_1.useEffect)(function () {
            var id = setInterval(function () { return setNow(Date.now()); }, intervalMs);
            return function () { return clearInterval(id); };
        }, [intervalMs]);
        return now;
    }
    if (isMinimized) {
        return react_1.default.createElement(MinimizedDock_1.default, { onRestore: handleRestore });
    }
    return (react_1.default.createElement("div", { ref: widgetRef },
        react_1.default.createElement(ModalWindow_1.default, { visible: visible, setVisible: setVisible }),
        react_1.default.createElement("div", { style: __assign({ position: "relative", width: panelWidth, borderRadius: 16, background: "#fff", border: "1px solid #E5E7EB", zIndex: 1000, overflow: "hidden", fontFamily: "Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial", transition: "width ".concat(motionMs, "ms ").concat(motionEasing), willChange: "width" }, (isMobile && {
                maxWidth: "100vw",
                margin: "0 auto",
            })) },
            react_1.default.createElement(HeaderBar_1.default, { title: currentView === "welcome"
                    ? "Welcome"
                    : currentView === "chat"
                        ? "Chat with Us"
                        : "Call Us", showBack: currentView !== "welcome", showMinimize: true, showClose: currentView !== "welcome", closeEnabled: currentView === "chat" || callState === "active", onBack: function () { return setCurrentView("welcome"); }, onMinimize: handleMinimize, onRequestClose: function () { return setShowConfirmClose(true); } }),
            react_1.default.createElement(AnimatedContainer_1.default, { viewKey: currentView }, currentView === "welcome" ? (react_1.default.createElement(WelcomeView_1.default, { onSelectChat: function () { return setCurrentView("chat"); }, onSelectCall: function () { return setCurrentView("call"); } })) : currentView === "chat" ? (react_1.default.createElement(ChatView_1.default, { messages: chatMessages, inputValue: chatInput, onChangeInput: setChatInput, onSend: handleSend, onEmoji: function () { return console.log("emoji"); }, onAttach: function () { return console.log("attach"); } })) : (react_1.default.createElement(CallView_1.default, { callState: callState, micStatus: micStatus, onStartEnd: handleWidgetClick, onMute: muteMicrophone, onUnmute: unmuteMicrophone }))),
            react_1.default.createElement(ConfirmCloseModal_1.default, { open: showConfirmClose, mode: currentView === "chat" ? "chat" : "call", onConfirm: function () { return __awaiter(_this, void 0, void 0, function () {
                    var e_3;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                setShowConfirmClose(false);
                                if (!(currentView === "chat")) return [3 /*break*/, 6];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 4, , 5]);
                                if (!chatId) return [3 /*break*/, 3];
                                return [4 /*yield*/, (0, retellClient_1.endChat)(chatId)];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3: return [3 /*break*/, 5];
                            case 4:
                                e_3 = _a.sent();
                                console.error(e_3);
                                return [3 /*break*/, 5];
                            case 5:
                                setChatId(null);
                                chatInitRequestedRef.current = false; // allow new session next time
                                setChatMessages([]);
                                setCurrentView("welcome");
                                return [3 /*break*/, 7];
                            case 6:
                                endCallSession();
                                setCurrentView("welcome");
                                _a.label = 7;
                            case 7: return [2 /*return*/];
                        }
                    });
                }); }, onCancel: function () { return setShowConfirmClose(false); } }),
            react_1.default.createElement("div", { style: {
                    padding: "8px 12px 14px",
                    borderTop: "1px solid #F0F2F5",
                    textAlign: "center",
                    fontSize: 12,
                    color: "#6B7280",
                } },
                "Powered by ",
                react_1.default.createElement("span", { style: { fontWeight: 600 } }, "ConnexUs AI")))));
}
exports.default = ChatWidget;
